export default defineNuxtRouteMiddleware((to) => {
  // 仅在客户端进行 UA 设备判断与重定向，避免 SSR/SEO 问题
  if (typeof navigator === 'undefined') {
    return
  }

  const isMobile = /(Android|webOS|iPhone|iPod|tablet|BlackBerry|Mobile)/i.test(navigator.userAgent)
  const isRouterMobile = /^\/m\//.test(to.fullPath)

  // 移动端访问非 /m 路由，重定向到 /m 前缀
  if (isMobile && !isRouterMobile) {
    return navigateTo(`/m${to.fullPath}`)
  }

  // 桌面端访问 /m 路由，重定向到普通路径
  if (!isMobile && isRouterMobile) {
    return navigateTo(to.fullPath.replace('/m', ''))
  }
})
